import axios from "axios";

// Create an Axios instance with default configuration
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL_MONTYPAY_TRANSACTION, // Base URL for the API
  headers: {
    "Api-Key": import.meta.env.VITE_API_KEY,
    Tenant: import.meta.env.VITE_TENANT,
  },
});

// Optional: Add interceptors if needed (for example, to log errors)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle error
    console.error("API Error:", error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
